// Anonymous demo sessions.
//
// Every visitor to Commons gets an isolated private copy of the seed. The
// session ID is generated once per browser (crypto.randomUUID) and persisted
// to localStorage under `commons.session.v1`. It is attached to every API
// request as `X-Session-Id`, so the backend can store per-session state in
// its own MongoDB document.
//
// Reset support:
//   `?reset=true` on any URL wipes this session's state, clears the local
//   identity, and reseeds from the canonical demo.

const SESSION_KEY = "commons.session.v1";
const USER_KEY = "commons.user.v1";

function generateSessionId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  // Fallback for older browsers.
  return "sess-" + Math.random().toString(36).slice(2) + Date.now().toString(36);
}

export function getSessionId() {
  if (typeof window === "undefined") return "server";
  let sid = localStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid = generateSessionId();
    localStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
}

export function clearLocalUser() {
  if (typeof window !== "undefined") localStorage.removeItem(USER_KEY);
}

// Read + consume the ?reset=true flag so opening `/demo?reset=true` (or any
// other URL) wipes just this visitor's session before the app initialises.
export function consumeResetFlag() {
  if (typeof window === "undefined") return false;
  const url = new URL(window.location.href);
  if (url.searchParams.get("reset") === "true") {
    url.searchParams.delete("reset");
    window.history.replaceState({}, "", url.toString());
    return true;
  }
  return false;
}

// Read + consume the ?autotour=1 flag. `/demo/fresh` redirects to
// `/?autotour=1` after wiping storage; TourProvider watches for this and
// launches the guided tour automatically once user + data are ready.
export function consumeAutoTourFlag() {
  if (typeof window === "undefined") return false;
  const url = new URL(window.location.href);
  if (url.searchParams.get("autotour") === "1") {
    url.searchParams.delete("autotour");
    window.history.replaceState({}, "", url.toString());
    return true;
  }
  return false;
}
